import { addStyles } from 'ethcss'
import { grid, item, IStyles, mediaCSS } from '../../theme'
import { indents, layers } from 'blocks.app/config'
import { defaultThemeStyles } from 'blocks.app/app/app.theme.jcss'

const sidebars = {
    right: '30%',
}

const modalStyles: IStyles = {
    wrapper: {
        ...grid.row,
        ...grid.center,
        ...grid.normalCenter,
        ...item.transition,
        ...item.fixed,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
    wrapper_h: {
        paddingTop: 64,
    },
    /* sidebars */
    sidebarsWrapper: {
        ...grid.row,
        ...grid.full,
    },
    sidebarsContent: {
        width: 0,
        ...grid.space,
        ...grid.fullHeight,
        background: `var(--var-module-app-component-app-style-background, ${defaultThemeStyles.background})`,
    },
    sidebarsLeft: {
        ...grid.fullHeight,
        ...item.greyLight,
    },
    sidebarsRight: {
        ...grid.fullHeight,
        ...item.shadow,
        overflowY: 'auto',
        width: sidebars.right,
        ...item.white,
        [mediaCSS.tab]: {
            width: '40%',
        },
    },
    /* /sidebars */
    content: {
        ...grid.full,
    },
    white: {
        backgroundColor: 'rgba(255, 255, 255, 1)',
    },
    opacity: {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
    clear: {
        background: 'none',
    },
    black: {
        ...item.blackOpacity,
    },
    button: {
        ...item.abs,
        right: indents.md,
        top: indents.md,
        zIndex: layers.drop,
    },
    button_h: {
        ...item.abs,
        right: indents.md,
        top: 90,
        zIndex: layers.drop,
    },
    modalOpen: {
        ...grid.full,
        ...item.overNone,
    },
    backButtonContainer: {
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: 1440,
        padding: 30,

        [mediaCSS.desktopML]: {
            width: 1240,

            [mediaCSS.desktopL]: {
                width: 768,
                padding: '30px 10px',

                [mediaCSS.tab]: {
                    width: '100%',
                },
            },
        },
    },
    backButton: {
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        left: 16,
        top: 32,
        fontSize: 16,
        cursor: 'pointer',
        zIndex: 10000,

        span: {
            marginLeft: 10,

            [mediaCSS.tab]: {
                display: 'none',
                top: 26,
            },
        },
    },
}

addStyles(modalStyles)
export default modalStyles
